<script lang="ts" setup>
import { inject, watch } from 'vue';

import type { Ref } from 'vue';
import type { IManifest, IManifestXYZPosition } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const skyboxRotation = inject('skyBoxRotation') as Ref<IManifestXYZPosition>;

const manifestWatcher = (newValue: IManifest) => {
  if (!newValue.skybox) return;
  skyboxRotation.value = newValue.skybox.skyboxRotation;
};

const skyboxRotationWatcher = (newValue: IManifestXYZPosition) => {
  if (!manifest.value.skybox) return;
  manifest.value.skybox.skyboxRotation = newValue;
};

watch(manifest, manifestWatcher);
watch(skyboxRotation, skyboxRotationWatcher, { deep: true });
</script>

<template>
  <div class="pl-2 font-mono text-sm leading-none flex flex-col">
    <div class="w-full flex flex-row">
      <label for="skybox-rotation-x" class="text-xs mr-2 mt-[5px]">x</label>
      <div class="border bg-white text-xs flex flex-row flex-grow items-center">
        <input
          id="skybox-rotation-x"
          v-model="skyboxRotation.x"
          type="number"
          step="0.01"
          min="0"
          :max="360"
          class="p-1 text-xs flex-grow bg-transparent"
        >
        <p class="bg-transparent px-1">
          deg
        </p>
      </div>
    </div>
    <div class="w-full flex flex-row">
      <label for="skybox-rotation-y" class="text-xs mr-2 mt-[5px]">y</label>
      <div class="border bg-white text-xs flex flex-row flex-grow items-center">
        <input
          id="skybox-rotation-y"
          v-model="skyboxRotation.y"
          type="number"
          step="0.01"
          min="0"
          :max="360"
          class="p-1 text-xs flex-grow bg-transparent"
        >
        <p class="bg-transparent px-1">
          deg
        </p>
      </div>
    </div>
    <div class="w-full flex flex-row">
      <label for="skybox-rotation-z" class="text-xs mr-2 mt-[5px]">z</label>
      <div class="border bg-white text-xs flex flex-row flex-grow items-center">
        <input
          id="skybox-rotation-z"
          v-model="skyboxRotation.z"
          type="number"
          step="0.01"
          min="0"
          :max="360"
          class="p-1 text-xs flex-grow bg-transparent"
        >
        <p class="bg-transparent px-1">
          deg
        </p>
      </div>
    </div>
  </div>
</template>
